export function required(value) {
    return !!value
}

export function requiredGeometry(value) {
    return !!value?.coordinates?.[0]?.[0]?.length
}

export function identityValue (value, compareValue) {
    return value === compareValue
}
export function email(value) {
    return !value ? true :  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
}

export function minLength(value, length) {
    return !value ? true : value.length >= length
}

export function maxLength(value, length) {
    return !value ? true : value.length <= length
}

export function betweenLength(value, minLength, maxLength) {
    return value.length <= maxLength && value.length >= minLength
}

export function beforeDate(value, before = Date.now()) {
    return new Date(value) <= before
}
export function maxValue(value, maxValue) {
    return +value <= +maxValue
}
export function minValue(value, minValue = 0) {
    if(value === '' || value === null) return true
    return +value >= minValue
}

export function includesOnlyNumbers(value) {
    return +value
}

export function positiveNumber(value) {
    if(+value > 0 || value === '' || value === null ) return true
    return false
}

export function positiveNumberWithNull(value) {
    if(+value >= 0 || value === '' || value === null ) return true
    return false
}

export function link(value) {
    return !value ? true : /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi.test(value)
}
export function phoneNumber(value) {
    return !value ? true : /^\+\d{10,}$/.test(value.replaceAll(' ', ''))
}

export function notEmptyArray(value) {
    return (value) => Array.isArray(value) && value.length
}

export function isJSONValid(jsonString) {
    try {
        JSON.parse(jsonString)
        return true
    } catch (e) {
        return false
    }
}
